// @ts-check
import { Component } from '@verndale/core';
import YouTubePlayer from 'yt-player';
import VimeoPlayer from '@vimeo/player';
import LimeLightPlayer from '../limelight';

class VideoItem extends Component {
  setupDefaults() {
    this.dom = {
      $imageContainer: this.el.querySelector('.card__image-container'),
      $playButton: this.el.querySelector('.video-item__icon-container'),
      $youTubePlayer: this.el.querySelector('.video-item__youtube-video'),
      $vimeoPlayer: this.el.querySelector('.video-item__vimeo-video'),
      $limelightPlayer: this.el.querySelector('.video-item__limelight-video')
    };

    this.nativePlayer = this.el.dataset.native;

    this.loaded = false;
    this.init();
  }

  addListeners() {
    this.dom?.$playButton?.addEventListener('click', () => this.playVideo());
    this.dom?.$playButton?.addEventListener('mouseover', () =>
      this.loadVideo()
    );
  }

  switchToVideo() {
    if (this.dom) {
      this.dom.$imageContainer.style.display = 'none';
      this.dom.$playButton.style.display = 'none';
    }
    this.el.classList.add('video-item--playing');
  }

  playVideo() {
    this.switchToVideo();
    this.player?.play();
    this.playerVimeo?.play();
  }

  pauseVideo() {
    this.player?.pause();
    this.playerVimeo?.pause();
  }

  loadVideo() {
    if (!this.loaded) {
      this.player?.load(this.videoId);
      this.loaded = true;
    }
  }

  init() {
    if (this.el.dataset.youtubeId) {
      this.player = new YouTubePlayer(this.dom?.$youTubePlayer);
      this.videoId = this.el.dataset.youtubeId;
    }

    if (this.dom?.$vimeoPlayer) {
      this.playerVimeo = new VimeoPlayer(this.dom?.$vimeoPlayer);
      this.videoId = this.el.dataset.videoId;
    }

    if (this.el.dataset.limelightId && !this.nativePlayer) {
      this.player = new LimeLightPlayer({ parent: this.dom?.$limelightPlayer });
      this.videoId = this.el.dataset.limelightId;
    }

    if (this.nativePlayer) {
      if (this.el.dataset.limelightId) {
        this.player = new LimeLightPlayer({
          settings: { mediaId: this.el.dataset.limelightId },
          parent: this.dom?.$limelightPlayer
        });
      } else {
        this.loadVideo();
      }
    }
  }
}

export default VideoItem;
